import React from "react";
import { observer } from "mobx-react";
import {
  Container,
  MasterContainer,
  LoaderWrapper,
  ErrorWrapper,
  EmptyWrapper,
} from "./All.styled";
import {
  CircularProgress,
  WidgetEmptyErrorPlaceholder,
} from "@ann/web-components";
import { Filters, Items, Paginator } from "./components";

const All = observer(
  ({
    items = [],
    meta,
    loading,
    error,
    onPageChange,
    onItemsPerPageChange,
    onRefresh,
    handleGetNoteDetail,
    handleUpdateNote,
    handleDeleteNote,
  }) => {
  const hasItems = items.length > 0;

  return (
    <MasterContainer>
      <Container>
        <Filters />
        {loading ? (
          <LoaderWrapper>
            <CircularProgress size="medium" />
          </LoaderWrapper>
        ) : error ? (
          <ErrorWrapper>
            <WidgetEmptyErrorPlaceholder
              icon="error"
              title="Something went wrong"
              message="We couldn't load recent activities. Please try again."
              buttonText="Retry"
              showButton={true}
              onClick={onRefresh}
            />
          </ErrorWrapper>
        ) : hasItems ? (
          <Items 
            items={items}
            handleGetNoteDetail={handleGetNoteDetail}
            handleUpdateNote={handleUpdateNote}
            handleDeleteNote={handleDeleteNote}
          />
        ) : (
          <EmptyWrapper>
            <WidgetEmptyErrorPlaceholder
              icon="searchOff"
              title="No recent activity"
              message="Will display the latest actions, messages, or service events."
              showButton={false}
            />
          </EmptyWrapper>
        )}
      </Container>
      {hasItems && (
        <Paginator
          meta={meta}
          loading={loading}
          onPageChange={onPageChange}
          onItemsPerPageChange={onItemsPerPageChange}
        />
      )}
    </MasterContainer>
  );
});

export default All;
